import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { NzCalendarI18nInterface } from '../../../i18n/nz-i18n.interface';
import { CandyDate } from '../candy-date';

@Component({
  selector: 'month-panel',
  template: `<div class="{{ prefixCls }}"> <div> <div class="{{ prefixCls }}-header"> <a class="{{ prefixCls }}-prev-year-btn" role="button" (click)="previousYear()" title="{{ locale.previousYear }}" ></a> <a class="{{ prefixCls }}-year-select" role="button" (click)="yearPanelShow.emit()" title="{{ locale.yearSelect }}" > <span class="{{ prefixCls }}-year-select-content">{{ value.getYear() }}</span> <span class="{{ prefixCls }}-year-select-arrow">x</span> </a> <a class="{{ prefixCls }}-next-year-btn" role="button" (click)="nextYear()" title="{{ locale.nextYear }}" ></a> </div> <div class="{{ prefixCls }}-body"> <month-table [disabledDate]="disabledDate" [value]="value" (valueChange)="valueChange.emit($event)"></month-table> </div> </div> </div>`
})

export class MonthPanelComponent implements OnInit {
  @Input() locale: NzCalendarI18nInterface;

  @Input() value: CandyDate;
  @Output() valueChange = new EventEmitter<CandyDate>();

  @Input() disabledDate: (date: Date) => boolean;

  @Output() yearPanelShow = new EventEmitter<void>();

  prefixCls: string = 'ant-calendar-month-panel';

  constructor() { }

  ngOnInit(): void { }

  previousYear(): void {
    this.gotoYear(-1);
  }

  nextYear(): void {
    this.gotoYear(1);
  }

  // Re-render panel content by the header's buttons (NOTE: Do not try to trigger final value change)
  private gotoYear(amount: number): void {
    this.value = this.value.addYears(amount);
    // this.valueChange.emit(this.value); // Do not try to trigger final value change
  }
}
